let video1 = document.querySelector("#video1");
let video2 = document.querySelector("#video2");
let video3 = document.querySelector("#video3");
let video3Replay = document.querySelector(".video3-replay");


function fadeInOnScroll(element, className) {
  const isInViewport = function(element) {
    const rect = element.getBoundingClientRect();
    let windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return (
      rect.top >= 0 && rect.top <= (windowHeight-(windowHeight*0.2))
      // rect.left >= 0 &&
      // rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      // rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  let video2Play = 0;
  let video3Play = 0;

  const handleScroll = function() {
    
    if (isInViewport(element)) {
      
      if(className === '#video2' && video2Play === 0){
        video2.currentTime = 0;
        video2.play()
        video2Play = 1
      }else if(className === '#video3' && video3Play === 0){
        video3Replay.style.display = 'none'
        video3.currentTime = 0;
        video3.play()
        video3Play = 1
      }else {
        element.classList.add(className);
      }
      // window.removeEventListener('scroll', handleScroll);
    }else {
      // element.classList.remove('fade-in-bl');
    }
  };

  window.addEventListener('scroll', handleScroll);
}

fadeInOnScroll(document.querySelector('.box3-img-text1'), 'fade-in');
fadeInOnScroll(document.querySelector('.box3-img-text2'), 'fade-in');
fadeInOnScroll(document.querySelector('.box3-info'), 'fade-in');
fadeInOnScroll(document.querySelector('.box11-c-l_top'), 'fade-in-top');

fadeInOnScroll(document.querySelector('.box2-title'), 'fade-in');
fadeInOnScroll(document.querySelector('.box2-video'), 'fade-in');
fadeInOnScroll(document.querySelector('.box3-img'), 'fade-in');
fadeInOnScroll(document.querySelector('.box4-title'), 'fade-in');
fadeInOnScroll(document.querySelector('#video2'), '#video2');
fadeInOnScroll(document.querySelector('#video3'), '#video3');
fadeInOnScroll(document.querySelector('.box4-r-text'), 'fade-in');
fadeInOnScroll(document.querySelector('.box4-r-ul'), 'fade-in');
fadeInOnScroll(document.querySelector('.box5-c-1_l'), 'fade-in');
fadeInOnScroll(document.querySelector('.box5-c-2_r'), 'fade-in');


fadeInOnScroll(document.querySelector('.box5-title'), 'fade-in');
fadeInOnScroll(document.querySelector('.box5-c-1_r'), 'fade-in');
fadeInOnScroll(document.querySelector('.box5-c-2_l'), 'fade-in');
fadeInOnScroll(document.querySelector('.box6-title'), 'fade-in');
fadeInOnScroll(document.querySelector('.box7-title'), 'fade-in');
fadeInOnScroll(document.querySelector('.box7-c-img'), 'fade-in');
fadeInOnScroll(document.querySelector('.box7-c-text1'), 'fade-in');
fadeInOnScroll(document.querySelector('.box7-c-text2'), 'fade-in');

fadeInOnScroll(document.querySelector('.box8-title'), 'fade-in');
fadeInOnScroll(document.querySelector('.box8-icon'), 'fade-in');
fadeInOnScroll(document.querySelector('.box8-b-img'), 'fade-in');
fadeInOnScroll(document.querySelector('.box9-title'), 'fade-in');
fadeInOnScroll(document.querySelector('.box9-img'), 'fade-in');
fadeInOnScroll(document.querySelector('.box10-title'), 'fade-in');
fadeInOnScroll(document.querySelector('.box10-img1'), 'fade-in');
// fadeInOnScroll(document.querySelector('.box10-img2'), 'fade-in');
fadeInOnScroll(document.querySelector('.box-10-c_2-r'), 'fade-in');
// fadeInOnScroll(document.querySelector('.box-10-c_2-l'), 'fade-in');
fadeInOnScroll(document.querySelector('.box-10-c_3-l'), 'fade-in');
// fadeInOnScroll(document.querySelector('.box10-img4'), 'fade-in');

fadeInOnScroll(document.querySelector('.box3-mb-t'), 'fade-in');
fadeInOnScroll(document.querySelector('.box3-mb-b-img'), 'fade-in');
fadeInOnScroll(document.querySelector('.box3-mb-img-text1'), 'fade-in');
fadeInOnScroll(document.querySelector('.box3-mb-img-text2'), 'fade-in');
fadeInOnScroll(document.querySelector('.box6-mb-t'), 'fade-in');
// fadeInOnScroll(document.querySelector('.box6-mb-b-img'), 'fade-in');
fadeInOnScroll(document.querySelector('.box6-mb-list-ul-box'), 'fade-in');
fadeInOnScroll(document.querySelector('.box6-mb-c-r'), 'fade-in');
fadeInOnScroll(document.querySelector('.box7-mb-box1'), 'fade-in');
fadeInOnScroll(document.querySelector('.box7-mb-box2'), 'fade-in');






video3Replay.addEventListener('click', ()=>{
  video3Replay.style.display = 'none'
  video3.play()
})
video3.addEventListener('ended', ()=>{
  video3Replay.style.display = 'flex'
})




let marker = document.querySelector("#marker2");
let tabItem = document.querySelectorAll(".box9-tab a");
let tabItemContent = document.querySelectorAll(".box9-tab-c-item");
let box1Info = document.querySelector(".box1-info");
let box1Img = document.querySelector(".box1-c-img");

function indicator(e){
  marker.style.left = e.offsetLeft + 'px';
  marker.style.width = e.offsetWidth + 'px';
}

tabItem.forEach((link,index) => {
  
  link.addEventListener('click', (e)=>{
    indicator(e.target)

    tabItemContent.forEach(item => {
      item.classList.remove("box9-active");
    })
    tabItem.forEach(item => {
      item.classList.remove("box9-tab-active");
    })

    tabItem[index].classList.add("box9-tab-active");
    tabItemContent[index].classList.add("box9-active");
  })

})


if (window.innerWidth < 992) {
  // 处理窗口宽度小于 1000 像素时的逻辑
  video1.src = "https://cdn.shopify.com/videos/c/o/v/f075f16610c7425683330f077b841e4f.mp4";
  video1.poster = "https://cdn.shopify.com/s/files/1/0604/6410/3654/files/01_intro__.mp4_20230424_110033.705.jpg?v=1682305282";
  video2.src = "https://cdn.shopify.com/videos/c/o/v/f900ff5293f7437989880db165fa963a.mp4";
  video2.poster = "https://cdn.shopify.com/s/files/1/0604/6410/3654/files/06_apps.jpg?v=1682492739";
  box1Info.classList.add("box1-info-animation")
}else{
  video1.src = "https://cdn.shopify.com/videos/c/o/v/494907676e3a43d2a74f26022c14ece3.mp4";
  video1.poster = "https://cdn.shopify.com/s/files/1/0604/6410/3654/files/01_intro.mp4_20230423_102702.781.jpg?v=1682216839";
  video2.src = "https://cdn.shopify.com/videos/c/o/v/dc48c285a4764f789e9f7112cb77afbd.mp4";
  video2.poster = "https://cdn.shopify.com/s/files/1/0604/6410/3654/files/07-1_apps.mp4_20230421_155014.869.jpg?v=1682063424";
  video1.addEventListener('ended', function () { //结束
  box1Info.classList.add("box1-info-animation")
  box1Img.classList.add("box1-info-animation")
  }, false);
}

// function checkWindowWidth() {
//   if (window.innerWidth < 992) {
//     // 处理窗口宽度小于 1000 像素时的逻辑
//     video1.src = "https://cdn.shopify.com/videos/c/o/v/f075f16610c7425683330f077b841e4f.mp4";
//     video1.poster = "https://cdn.shopify.com/s/files/1/0604/6410/3654/files/01_intro__.mp4_20230424_110033.705.jpg?v=1682305282";
//     box1Info.classList.add("box1-info-animation")
//   }else{
//     video1.src = "https://cdn.shopify.com/videos/c/o/v/494907676e3a43d2a74f26022c14ece3.mp4";
//     video1.poster = "https://cdn.shopify.com/s/files/1/0604/6410/3654/files/01_intro.mp4_20230423_102702.781.jpg?v=1682216839";
//     video1.addEventListener('ended', function () { //结束
//     box1Info.classList.add("box1-info-animation")
//     box1Img.classList.add("box1-info-animation")
//     }, false);
//   }
// }

// window.addEventListener("resize", checkWindowWidth);

// // 页面加载时检查窗口宽度
// checkWindowWidth();

// let box3A = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".box3",
//     start: "center center",
//     end: "bottom top",
//     scrub: true,
//     // markers: true,
//     pin: true
//   }
// })

// box3A.to(".box3-c", {y: 80})
// box3A.from(".box3-img_item", {opacity: 0,x:-200})
// box3A.to(".box3-info", {opacity: 1})
// box3A.from(".box3-img-text1", {opacity: 0,x:-100})
// box3A.from(".box3-img-text2", {opacity: 0,x:-100})


let box6A = gsap.timeline({
  scrollTrigger: {
    trigger: ".box6-c",
    start: "center center",
    end: "bottom top",
    scrub: true,
    // markers: true,
    pin: true
  }
})
box6A.to(".box6-c-l", {
  rotation: 0,
  duration: 1,
  x: -200,
  y: 50
})
box6A.to(".box6-l-img_2", {opacity: 0})
box6A.from(".box6-c-r", {opacity: 0,x:100})
box6A.from(".list-ul-box", {opacity: 0,x:-100})